<ngx-loading [show]="loading"></ngx-loading>

<div class="modal-header border-0 p-0">
  <button type="button" class="btn white-font p-0 ml-auto mr-2" aria-label="Close" (click)="dismissModal()">
    <i class="fal fa-times"></i>
  </button>
</div>

<div class="container p-0 pb-3">
  <div class="search-container navy-background justify-content-center section-container">
    <h6 class="modal-title text-uppercase white-font text-center mb-4">Select Clinic Supplies</h6>
    <div class="input-group pb-2">
      <div class="input-group-prepend">
        <div class="input-group-text border-radius grey-three-background border-0">
          <i class="fa fa-search"></i>
        </div>
      </div>
      <input
        [formControl]="searchFormControl"
        type="text"
        name="supplySearch"
        class="form-control border-0 grey-three-background"
        placeholder="Search"
      />
    </div>
  </div>

  <div class="selection-container" [ngClass]="{ 'bottom-margin': selectedSupplies.size > 0 }">
    <div *ngIf="selectedSupplies.size > 0" class="selected-supply-header">Selected Supplies</div>
    <div *ngFor="let entry of selectedSupplies | keyvalue; trackBy: trackBySupply" class="selected-supply">
      <div class="mr-auto">{{ entry.key.name }}</div>
      <div class="quantity-input-container">
        <label class="qty-label">Qty:</label>
        <input
          type="number"
          min="1"
          class="quantity-input"
          [value]="entry.value"
          (input)="updateQuantity(entry.key, +$any($event.target).value)"
          (keydown)="preventFocusLoss($event)"
        />
      </div>
      <div class="price-display">${{ entry.key.pricePerUnit || 0 }}</div>
      <span class="unselect" (click)="unselectSupply(entry.key)">
        <i class="fal fa-times"></i>
      </span>
    </div>
  </div>

  <div class="list-container">
    <ng-scrollbar *ngIf="supplyTypeGroups?.size > 0; else noSupplies" class="h-100">
      <mat-accordion multi>
        <ng-container *ngFor="let supplyTypeGroup of supplyTypeGroups | keyvalue">
          <mat-expansion-panel *ngIf="supplyTypeGroup.value.length > 0" [expanded]="shouldExpand" class="my-1">
            <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
              <mat-panel-title>
                {{ supplyTypeGroup.key }}
              </mat-panel-title>
              <mat-icon>arrow_drop_up</mat-icon>
            </mat-expansion-panel-header>
            <div class="supply-item navy-font font-weight-bold">
              <div class="name-col">Name</div>
              <div class="qty-col">Units On Hand</div>
              <div class="price-col">Price Per Unit</div>
              <div class="checkbox-col">
                <mat-checkbox class="invisible"> </mat-checkbox>
              </div>
            </div>
            <div *ngFor="let supply of supplyTypeGroup.value" class="supply-item navy-font">
              <div class="name-col">{{ supply.name }}</div>
              <div class="qty-col">{{ supply.unitsOnHand || '-' }}</div>
              <div class="price-col">${{ supply.pricePerUnit || 0 }}</div>
              <div class="checkbox-col">
                <mat-checkbox [checked]="supplyIsSelected(supply)" (change)="toggleSupplySelection(supply)">
                </mat-checkbox>
              </div>
            </div>
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>
    </ng-scrollbar>
    <ng-template #noSupplies
      ><div class="text-center"><h6>No clinic supplies found.</h6></div></ng-template
    >
  </div>

  <div class="save-changes-container my-3 text-center">
    <button class="btn em-btn em-btn-green mr-2" [disabled]="selectedSupplies.size === 0" (click)="closeModal()">
      Add
    </button>
    <button class="btn em-btn em-btn-green" (click)="dismissModal()">Cancel</button>
  </div>
</div>

